import { render, staticRenderFns } from "./LocaleSwitch.html?vue&type=template&id=ea9cfed2&external"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports